module.exports = __webpack_public_path__ + "media/images/flags/eu-f11d58adf67c5e39d2db4f50bd2bf0cf.svg";